import router from "../../../../router";
import config from "../../../config";
import sendRequest from "../../../helpers/requestHelper";

const tokenResetPasswordExist = {
    namespaced: true,
    state: {
      tokenExist: false
    },
    mutations: {
        UPDATE_VISIBLE_MODAL(state, value) {
            state.isUserResetPassword = value;
        },
        TOKEN_EXIST(state) {
            state.tokenExist = true;
        },
        TOKEN_NOT_EXIST(state) {
            state.tokenExist = false;
        }
    },
    actions: {
        isTokenExist: function({ dispatch, state }, payload) {
            var promise = sendRequest("post", config.baseURLApi+'/users/token/exist', {}, payload.creds, false);
            promise.then(function($result) {
                if($result[0] === "success") {
                    dispatch("tokenExist", $result[1]);
                } else {
                    dispatch("tokenNotExist", $result[1]);
                }
                if(!state.tokenExist) {
                    router.push("/error/404");
                }
            });
        },
        tokenExist: function({ commit }, response) {
            commit("TOKEN_EXIST", response);
        },
        tokenNotExist: function({ commit }, error) {
            commit("TOKEN_NOT_EXIST", error);
        },
        updateVisibleModal: function({ commit }, value) {
            commit("UPDATE_VISIBLE_MODAL", value);
        }
    }
}

export default tokenResetPasswordExist;